const connections = [
  { icon: 'ri-crosshair-line', title: 'Понятные цели', desc: 'Сотруднику должно быть ясно, что именно и к какому результату он должен прийти.' },
  { icon: 'ri-user-location-line', title: 'Ощущение ответственности', desc: 'Ответственность за конкретный результат, а не просто выполнение поручений.' },
  { icon: 'ri-vip-crown-line', title: 'Качество руководства', desc: 'То, как руководитель ставит задачи, контролирует и общается, влияет на мотивацию сильнее любых программ.' },
  { icon: 'ri-chat-3-line', title: 'Обратная связь', desc: 'Своевременная обратная связь о результате и развитии, а не только критика после ошибки.' },
  { icon: 'ri-graduation-cap-line', title: 'Возможность развития', desc: 'Сотрудник видит, куда он растёт и какие навыки приобретает в текущей работе.' },
  { icon: 'ri-file-list-3-line', title: 'Понятные правила', desc: 'Прозрачные правила работы, оценки и взаимодействия без двойных стандартов.' },
  { icon: 'ri-award-line', title: 'Признание результата', desc: 'Достижения замечаются и признаются, а не воспринимаются как само собой разумеющееся.' },
  { icon: 'ri-compass-3-line', title: 'Автономность', desc: 'Возможность самостоятельно принимать решения в своей зоне ответственности.' },
  { icon: 'ri-chat-heart-line', title: 'Качество коммуникации', desc: 'Открытый и уважительный диалог вместо общения приказами и односторонними указаниями.' },
  { icon: 'ri-scales-3-line', title: 'Справедливость решений', desc: 'Последовательные управленческие решения, понятные всей команде.' },
  { icon: 'ri-hand-heart-line', title: 'Отношение руководителя', desc: 'Уважение к сотрудникам как к людям, а не как к исполнителям функций.' },
];

export default function WhatMotivationMeans() {
  return (
    <section className="py-16 md:py-24 bg-gray-50">
      <div className="max-w-7xl mx-auto px-6">
        <h2 className="text-2xl md:text-4xl font-bold text-gray-900 text-center mb-3">
          Мотивация сотрудников — это не только деньги
        </h2>
        <p className="text-base md:text-lg text-gray-600 text-center mb-12 max-w-3xl mx-auto leading-relaxed">
          Снижение эффективности команды нельзя автоматически решать повышением зарплаты или введением новых бонусов
        </p>

        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-5 mb-12">
          {connections.map((item) => (
            <div key={item.title} className="bg-white rounded-xl border border-gray-200 p-5 md:p-6 hover:border-teal-300 transition-colors">
              <div className="w-10 h-10 rounded-full bg-teal-100 flex items-center justify-center mb-4">
                <i className={`${item.icon} text-teal-700 text-lg`}></i>
              </div>
              <h3 className="font-bold text-gray-900 text-sm mb-2">{item.title}</h3>
              <p className="text-gray-600 text-xs leading-relaxed">{item.desc}</p>
            </div>
          ))}
        </div>

        <div className="bg-teal-50 rounded-xl border border-teal-200 p-6 md:p-8 max-w-4xl mx-auto">
          <p className="text-base text-teal-800 leading-relaxed">
            Материальное вознаграждение — важная, но не единственная часть системы мотивации. Деньги могут снять остроту недовольства, но не заменят понятных целей, ответственности, качественного руководства и обратной связи. Поэтому мы рассматриваем мотивацию комплексно: как сочетание материальных стимулов, организации работы и управленческих практик, а не как набор отдельных нематериальных «фишек».
          </p>
        </div>
      </div>
    </section>
  );
}